import { useState } from "react";
import { Phone, MessageCircle, X } from "lucide-react";
import { CONTACT } from "@/lib/api";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-24 right-6 z-40" data-testid="floating-contact">
      {open && (
        <div className="mb-4 flex flex-col gap-3 items-end fade-up">
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            data-testid="float-whatsapp"
            className="flex items-center gap-3 bg-[#25D366] text-black px-5 py-3 uppercase tracking-widest text-xs hover:scale-105 transition-transform"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
          <a
            href={`viber://chat?number=%2B${CONTACT.viber}`}
            data-testid="float-viber"
            className="flex items-center gap-3 bg-[#7360F2] text-white px-5 py-3 uppercase tracking-widest text-xs hover:scale-105 transition-transform"
          >
            <MessageCircle size={16} /> Viber
          </a>
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="float-call"
            className="flex items-center gap-3 bg-[var(--gold)] text-black px-5 py-3 uppercase tracking-widest text-xs hover:scale-105 transition-transform"
          >
            <Phone size={16} /> Call Now
          </a>
        </div>
      )}

      <button
        data-testid="floating-contact-toggle"
        onClick={() => setOpen((o) => !o)}
        className="w-16 h-16 rounded-full flex items-center justify-center hover:scale-105 transition-transform"
        style={{
          background: "linear-gradient(135deg, #f4d28c 0%, #e6c27a 50%, #e8b4c9 100%)",
          color: "#1a0a0f",
          boxShadow: "0 0 50px rgba(232,180,201,0.5), 0 0 30px rgba(230,194,122,0.3)",
        }}
        aria-label="Contact"
      >
        {open ? <X size={22} /> : <Phone size={22} />}
      </button>
    </div>
  );
}
